import React, { useState, useEffect } from 'react';
import dataService from '../../../../service/dataService';



// Optional: Define props for the component, such as a callback for selecting a name.
interface UniqueNameDropdownProps {
  onNameSelect: (name: string) => void;
}


const UniqueNameDropdown: React.FC<UniqueNameDropdownProps> = ({ onNameSelect }) => {
  const [uniqueNames, setUniqueNames] = useState<string[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    const fetchNames = async () => {
      try {
        const names = await dataService.getUniqueFullNames('students');
        setUniqueNames(names);
      } catch (err) {
        setError('Failed to fetch names.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchNames();
  }, []);

  if (loading) {
    return <div>Loading names...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div className="dropdown-container">
     <label htmlFor="Select a Student Name" className="text-sm text-navy-700 dark:text-white ml-3 font-bold">
         Select a Student Name
     </label>
      <select className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" id="unique-name-select" 
      onChange={(e) => onNameSelect(e.target.value)}>
        <option value="">--Please choose an option--</option>
        {uniqueNames.map((name) => (
          <option key={name} value={name}>
            {name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default UniqueNameDropdown;